import request from './request-saga';

export default request;
